// ProductItem.js

import React from 'react';
import axios from 'axios';
import './ProductItem.css';

const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';

const ProductItem = ({ product, fetchProducts, onEdit }) => {
    const handleDelete = async () => {
        const confirmDelete = window.confirm(`¿Estás seguro de que deseas eliminar el producto "${product.name}"?`);
        if (!confirmDelete) return;

        try {
            const token = localStorage.getItem('token');
            if (!token) {
                alert('No estás autenticado. Por favor, inicia sesión.');
                return;
            }

            await axios.delete(`${apiUrl}/api/products/${product._id}`, {
                headers: {
                    Authorization: token
                }
            });

            alert('Producto eliminado con éxito');
            fetchProducts();
        } catch (error) {
            console.error('Error al eliminar el producto:', error);
            alert('Error al eliminar el producto: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleEdit = () => {
        onEdit(product);
    };

    const toggleRecommendation = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.put(
                `${apiUrl}/api/products/recommend/${product._id}`,
                {},
                {
                    headers: {
                        Authorization: token
                    }
                }
            );
            alert(`Producto actualizado: ${response.data.recommended ? 'Recomendado' : 'No recomendado'}`);
            fetchProducts(); // Refrescar productos para reflejar el cambio
        } catch (error) {
            console.error('Error al actualizar recomendación:', error);
            alert('Error al actualizar el estado de recomendación');
        }
    };

    return (
        <div className="product-item">
            <button onClick={toggleRecommendation} className="recommend-button">
                {product.recommended ? '★' : '☆'}
            </button>
            <div className="product-info">
                <h3>{product.name}</h3>
                <p>{product.description}</p>
                <p>Precio: €{product.price.toFixed(2)}</p>
                <p>Stock: {product.stock}</p>
            </div>
            <div className="product-actions">
                <button onClick={handleEdit} className="edit-button">Editar</button>
                <button onClick={handleDelete} className="delete-button">Eliminar</button>
            </div>
        </div>
    );
};

export default ProductItem;
